// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"682cc0e3","362":"9a58bf9b"}[chunkId] + ".chunk.css";
};